import React, { useState, useEffect } from 'react';
import {
  Box,
  CircularProgress,
  Typography,
  Container,
  List,
  ListItem,
  Alert,
  Paper,
  IconButton
} from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import ActionCard from '../../components/Actions/ActionCard';
import { getActions } from '../../service/Actions/getActions';
import { useNavigate } from 'react-router-dom';
import { getCurrentDateInISOFormat } from '../../service/Util/dateTimeUtil';

const OverdueActions = ({ route }) => {
  const navigate = useNavigate();

  const [overdueActions, setOverdueActions] = useState([]);
  const [isLoadingOverdueActions, setIsLoadingOverdueActions] = useState(true);
  const [isErrorLoadingOverdues, setIsErrorLoadingOverdues] = useState(false);

  const fetchOverdueActions = async () => {
    setIsErrorLoadingOverdues(false);
    setIsLoadingOverdueActions(true);

    try {
      const resData = await getActions(0, 1);
      const fetchedActions = resData.data;
      setOverdueActions([...fetchedActions]);
      setIsLoadingOverdueActions(false); 
    } catch (error) {
      setIsLoadingOverdueActions(false); 
      setIsErrorLoadingOverdues(true);
    }
  };

  useEffect(() => {
    fetchOverdueActions();
  }, []);

  const renderOverdueAction = (item) => {
    return (
      <ListItem key={item.actionID} sx={{ px: 0 }}>
        <ActionCard item={item} fromScreen='OverdueActionsScreen' />
      </ListItem>
    );
  };

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <Box
        sx={{
          backgroundColor: '#e6e6e6',
          minHeight: '100vh',
          p: 3,
          borderRadius: 1
        }}
      >
        {/* Loading State */}
        {isLoadingOverdueActions && (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        )}

        {/* Error State */}
        {!isLoadingOverdueActions && isErrorLoadingOverdues && (
          <Alert severity="error" sx={{ mb: 2 }}>
            Error loading overdue actions, please try again later.
          </Alert>
        )}

        {/* Empty State */}
        {!isLoadingOverdueActions && !isErrorLoadingOverdues && overdueActions.length === 0 && (
          <Paper elevation={1} sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="body1" color="text.secondary">
              There is no overdue action.
            </Typography>
          </Paper>
        )}

        {/* Data State */}
        {!isLoadingOverdueActions && !isErrorLoadingOverdues && overdueActions.length > 0 && (
          <Box>
            {/* Refresh Button */}
            <Box display="flex" justifyContent="flex-end" mb={2}>
              <IconButton
                onClick={fetchOverdueActions}
                disabled={isLoadingOverdueActions}
                color="primary"
                size="large"
              >
                <RefreshIcon />
              </IconButton>
            </Box>

            {/* Actions List */}
            <List sx={{ width: '100%' }}>
              {overdueActions.map(renderOverdueAction)}
            </List>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default OverdueActions;